// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"77862787","453":"8e9e3179","604":"53403d9b"}[chunkId] + ".chunk.js";
};